import {useQuery} from "react-query";
import {http} from "@firefly/fly-http";

export function useOrderWatch(no?: string) {
    return useQuery({
        queryKey: ['order', no, 'state'],
        enabled: !!no,
        queryFn: () => {
            return http.get(`/api/wangame/orders/no=${no ? encodeURIComponent(no) : undefined}`)
        },
        refetchInterval: (query) => {
            const data = query?.state?.data
            if (data?.paymentState === 'PAID') {
                return false;
            }
            return 1000;
        }
    })
}